import * as types from "./mutation_types";

export default {
  [types.tva_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.tva_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.tva_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.tva_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
